import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TextKeys {
  static mainMenu = {
    badge: 'mainMenu.badge',
    overview: 'mainMenu.overview',
    settings: 'mainMenu.settings',
    logout: 'mainMenu.logout',
    orders: 'mainMenu.orders',
    admin: 'mainMenu.admin',
    expenseDuplicatesReport: 'mainMenu.expenseDuplicatesReport',
  };

  static terminalGroup = {
    title: 'terminalGroup.title',
    numberShort: 'terminalGroup.numberShort',
  };

  static timeModel = {
    title: 'timeModel.title',
    select: 'timeModel.select',
    fromDate: 'timeModel.fromDate',
    numberShort: 'timeModel.numberShort',
  };

  static adminTools = {
    title: 'adminTools.title',
    personTools: 'adminTools.personTools',
    listDownloaded: 'adminTools.listDownloaded',
    setInitialPassword: 'adminTools.setInitialPassword',
    setInitialPasswordAll: 'adminTools.setInitialPasswordAll',
    setInitialPasswordSelected: 'adminTools.setInitialPasswordSelected',
    allPassword: 'adminTools.allPassword',
    selectedPerson: 'adminTools.selectedPerson',
    set: 'adminTools.set',
    activate: 'adminTools.activate',
    deactivate: 'adminTools.deactivate',
    askSetInitPasswordQuestion: 'adminTools.askSetInitPasswordQuestion',
    askSetInitPasswordAllQuestion: 'adminTools.askSetInitPasswordAllQuestion',
    sendEmail: 'adminTools.sendEmail',
    batchMutation: {
      tabChange: 'adminTools.batchMutation.tabChange',
      tabReplace: 'adminTools.batchMutation.tabReplace',
      tabPeriodic: 'adminTools.batchMutation.tabPeriodic',
      noSelectedPersonsValidationMessage:
        'adminTools.batchMutation.noSelectedPersonsValidationMessage',
      validFromDateRangeLabel:
        'adminTools.batchMutation.validFromDateRangeLabel',
      validationMessage: 'adminTools.batchMutation.validationMessage',
      timemodels: {
        title: 'adminTools.batchMutation.timemodels.title',
        validationMessage:
          'adminTools.batchMutation.timemodels.validationMessage',
        change: {
          changeTimeModelSelectionValidationMessage:
            'adminTools.batchMutation.timemodels.change.changeTimeModelSelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.timemodels.change.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.timemodels.change.userConfirmationExecuteBatchMutationTitle',
        },
        replace: {
          existingTimeModelSelectionLabel:
            'adminTools.batchMutation.timemodels.replace.existingTimeModelSelectionLabel',
          newTimeModelSelectionLabel:
            'adminTools.batchMutation.timemodels.replace.newTimeModelSelectionLabel',
          existimtTimeModelSelectionValidationMessage:
            'adminTools.batchMutation.timemodels.replace.existimtTimeModelSelectionValidationMessage',
          newTimeModelSelectionValidationMessage:
            'adminTools.batchMutation.timemodels.replace.newTimeModelSelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.timemodels.replace.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.timemodels.replace.userConfirmationExecuteBatchMutationTitle',
        },
        periodic: {
          peridicDTimeModelSelectionLabel:
            'adminTools.batchMutation.timemodels.periodic.peridicDTimeModelSelectionLabel',
          periodTypeLabel:
            'adminTools.batchMutation.timemodels.periodic.periodTypeLabel',
          periodTypeWeekLabel:
            'adminTools.batchMutation.timemodels.periodic.periodTypeWeekLabel',
          periodTypeMonthLabel:
            'adminTools.batchMutation.timemodels.periodic.periodTypeMonthLabel',
          periodIntervallLabel:
            'adminTools.batchMutation.timemodels.periodic.periodIntervallLabel',
          timemodelSelectionTablePosColumnTitle:
            'adminTools.batchMutation.timemodels.periodic.timemodelSelectionTablePosColumnTitle',
          timemodelSelectionTableNameColumnTitle:
            'adminTools.batchMutation.timemodels.periodic.timemodelSelectionTableNameColumnTitle',
          timemodelSelectionTableNumberColumnTitle:
            'adminTools.batchMutation.timemodels.periodic.timemodelSelectionTableNumberColumnTitle',
          timemodelSelectionTableRemoveColumnTitle:
            'adminTools.batchMutation.timemodels.periodic.timemodelSelectionTableRemoveColumnTitle',
          periodityIntervallValidationMessage:
            'adminTools.batchMutation.timemodels.periodic.periodityIntervallValidationMessage',
          timeModelSelectionValidationMessage:
            'adminTools.batchMutation.timemodels.periodic.timeModelSelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.timemodels.periodic.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.timemodels.periodic.userConfirmationExecuteBatchMutationTitle',
          userConfirmationPreviewReportLabel:
            'adminTools.batchMutation.timemodels.periodic.userConfirmationPreviewReportLabel',
          userConfirmationExecuteBatchMutationConfirmationLabel:
            'adminTools.batchMutation.timemodels.periodic.userConfirmationExecuteBatchMutationConfirmationLabel',
        },
      },
      departments: {
        title: 'adminTools.batchMutation.departments.title',
        validationMessage:
          'adminTools.batchMutation.departments.validationMessage',
        change: {
          changeDepartmentSelectionValidationMessage:
            'adminTools.batchMutation.departments.change.changeDepartmentSelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.departments.change.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.departments.change.userConfirmationExecuteBatchMutationTitle',
        },
        replace: {
          existingDepartmentSelectionLabel:
            'adminTools.batchMutation.departments.replace.existingDepartmentSelectionLabel',
          newDepartmentSelectionLabel:
            'adminTools.batchMutation.departments.replace.newDepartmentSelectionLabel',
          existimtDepartmentSelectionValidationMessage:
            'adminTools.batchMutation.departments.replace.existimtDepartmentSelectionValidationMessage',
          newDepartmentSelectionValidationMessage:
            'adminTools.batchMutation.departments.replace.newDepartmentSelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.departments.replace.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.departments.replace.userConfirmationExecuteBatchMutationTitle',
        },
        periodic: {
          peridicDepartmentSelectionLabel:
            'adminTools.batchMutation.departments.periodic.peridicDepartmentSelectionLabel',
          periodTypeLabel:
            'adminTools.batchMutation.departments.periodic.periodTypeLabel',
          periodTypeWeekLabel:
            'adminTools.batchMutation.departments.periodic.periodTypeWeekLabel',
          periodTypeMonthLabel:
            'adminTools.batchMutation.departments.periodic.periodTypeMonthLabel',
          periodIntervallLabel:
            'adminTools.batchMutation.departments.periodic.periodIntervallLabel',
          selectionTablePosColumnTitle:
            'adminTools.batchMutation.departments.periodic.selectionTablePosColumnTitle',
          selectionTableNameColumnTitle:
            'adminTools.batchMutation.departments.periodic.selectionTableNameColumnTitle',
          selectionTableNumberColumnTitle:
            'adminTools.batchMutation.departments.periodic.selectionTableNumberColumnTitle',
          selectionTableRemoveColumnTitle:
            'adminTools.batchMutation.departments.periodic.selectionTableRemoveColumnTitle',
          periodityIntervallValidationMessage:
            'adminTools.batchMutation.departments.periodic.periodityIntervallValidationMessage',
          selectionValidationMessage:
            'adminTools.batchMutation.departments.periodic.selectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.departments.periodic.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.departments.periodic.userConfirmationExecuteBatchMutationTitle',
        },
      },
      holidays: {
        title: 'adminTools.batchMutation.holidays.title',
        validationMessage:
          'adminTools.batchMutation.holidays.validationMessage',
        change: {
          currentHolidayModel:
            'adminTools.batchMutation.holidays.change.currentHolidayModel',
          changeHolidaySelectionValidationMessage:
            'adminTools.batchMutation.holidays.change.changeHolidaySelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.holidays.change.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.holidays.change.userConfirmationExecuteBatchMutationTitle',
        },
        replace: {
          existingHolidaySelectionLabel:
            'adminTools.batchMutation.holidays.replace.existingHolidaySelectionLabel',
          newHolidaySelectionLabel:
            'adminTools.batchMutation.holidays.replace.newHolidaySelectionLabel',
          existimtHolidaySelectionValidationMessage:
            'adminTools.batchMutation.holidays.replace.existimtHolidaySelectionValidationMessage',
          newHolidaySelectionValidationMessage:
            'adminTools.batchMutation.holidays.replace.newHolidaySelectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.holidays.replace.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.holidays.replace.userConfirmationExecuteBatchMutationTitle',
        },
        periodic: {
          peridicHolidaySelectionLabel:
            'adminTools.batchMutation.holidays.periodic.peridicHolidaySelectionLabel',
          periodTypeLabel:
            'adminTools.batchMutation.holidays.periodic.periodTypeLabel',
          periodTypeWeekLabel:
            'adminTools.batchMutation.holidays.periodic.periodTypeWeekLabel',
          periodTypeMonthLabel:
            'adminTools.batchMutation.holidays.periodic.periodTypeMonthLabel',
          periodIntervallLabel:
            'adminTools.batchMutation.holidays.periodic.periodIntervallLabel',
          selectionTablePosColumnTitle:
            'adminTools.batchMutation.holidays.periodic.selectionTablePosColumnTitle',
          selectionTableNameColumnTitle:
            'adminTools.batchMutation.holidays.periodic.selectionTableNameColumnTitle',
          selectionTableNumberColumnTitle:
            'adminTools.batchMutation.holidays.periodic.selectionTableNumberColumnTitle',
          selectionTableRemoveColumnTitle:
            'adminTools.batchMutation.holidays.periodic.selectionTableRemoveColumnTitle',
          periodityIntervallValidationMessage:
            'adminTools.batchMutation.holidays.periodic.periodityIntervallValidationMessage',
          selectionValidationMessage:
            'adminTools.batchMutation.holidays.periodic.selectionValidationMessage',
          userConfirmationExecuteBatchMutation:
            'adminTools.batchMutation.holidays.periodic.userConfirmationExecuteBatchMutation',
          userConfirmationExecuteBatchMutationTitle:
            'adminTools.batchMutation.holidays.periodic.userConfirmationExecuteBatchMutationTitle',
        },
      },
    },
  };

  static languages = {
    de: 'language.de',
    en: 'language.en',
    fr: 'language.fr',
    it: 'language.it',
    es: 'language.es',
  };

  static personal = {
    title: 'personal.title',
    numberLong: 'personal.numberLong',
    firstName: 'personal.firstName',
    lastName: 'personal.lastName',
    fullName: 'personal.fullName',
    numberShort: 'personal.numberShort',
    entryDate: 'personal.entryDate',
    addEntryDate: 'personal.addEntryDate',
    defaultWorkTitle: 'personal.defaultWorkTitle',
    working: 'personal.working',
    startTime: 'personal.startTime',
    stopTime: 'personal.stopTime',
    person: 'personal.person',
    gender: 'personal.gender',
    details: 'personal.details',
    id: 'personal.id',
    uploadImage: 'personal.uploadImage',
    birthday: 'personal.birthday',
    birthdayFrom: 'personal.birthdayFrom',
    birthdayTo: 'personal.birthdayTo',
    email: 'personal.email',
    emailSerialPrint: 'personal.emailSerialPrint',
    emailPrivate: 'personal.emailPrivate',
    emailPrivateSerialPrint: 'personal.emailPrivateSerialPrint',
    phone: 'personal.phone',
    phonePrivate: 'personal.phonePrivate',
    mobilePhone: 'personal.mobilePhone',
    language: 'personal.language',
    profession: 'personal.profession',
    bank: 'personal.bank',
    insuranceNumber: 'personal.insuranceNumber',
    note: 'personal.note',
    costRate: 'personal.costRate',
    password: 'personal.password',
    deleted: 'personal.deleted',
    workingToday: 'personal.workingToday',
    exitDate: 'personal.exitDate',
    addExitDate: 'personal.addExitDate',
    branchID: 'personal.branchID',
    branch: 'branch.title',
    holidayID: 'personal.holidayID',
    holidayName: 'personal.holidayName',
    superiorID: 'personal.superiorID',
    departmentID: 'personal.departmentID',
    departmentNumber: 'personal.departmentNumber',
    departmentName: 'personal.departmentName',
    groupID: 'personal.groupID',
    groupName: 'personal.groupName',
    groupAddition: 'personal.groupAddition',
    defaultOrderID: 'personal.defaultOrderID',
    defaultOrderName: 'personal.defaultOrderName',
    defaultOrderNumber: 'personal.defaultOrderNumber',
    defaultCostCenterID: 'personal.defaultCostCenterID',
    defaultCostCenterName: 'personal.defaultCostCenterName',
    defaultCostCenterNumber: 'personal.defaultCostCenterNumber',
    come: 'personal.come',
    go: 'personal.go',
    authorizeExceptionForBreakViolation:
      'personal.authorizeExceptionForBreakViolation',
    deleteAuthorizeExceptionForBreakViolation:
      'personal.deleteAuthorizeExceptionForBreakViolation',
    currentOrder: 'personal.currentOrder',
    currentOrder2: 'personal.currentOrder2',
    currentOrderCustomer: 'personal.currentOrderCustomer',
    currentCostCenter: 'personal.currentCostCenter',
    supervisor: 'personal.supervisor',
    noneSupervisor: 'personal.noneSupervisor',
    otherPersonalDataTitle: 'personal.otherPersonalDataTitle',
    assignment: {
      title: 'personal.assignment.title',
      deleteQuestion: 'personal.assignment.deleteQuestion',
      currentEntryTitle: 'personal.assignment.currentEntryTitle',
      entryDate: 'personal.assignment.entryDate',
      exitDate: 'personal.assignment.exitDate',
      delete: 'personal.assignment.delete',
      itemTitle: 'personal.assignment.itemTitle',
      edit: 'personal.assignment.edit',
      save: 'personal.assignment.save',
      newEntry: 'personal.assignment.newEntry',
    },
    timeline: {
      title: 'personal.timeline.title',
      timelineViewTitle: 'personal.timeline.timelineViewTitle',
      timelineViewShowAll: 'personal.timeline.timelineViewShowAll',
      timelineItemsNoItem: 'personal.timeline.timelineItemsNoItem',
      deleteTitle: 'personal.timeline.deleteTitle',
      deleteQuestion: 'personal.timeline.deleteQuestion',
      deleteTitleWithVisum: 'personal.timeline.deleteTitleWithVisum',
      deleteQuestionWithVisum: 'personal.timeline.deleteQuestionWithVisum',
      scopeAreaTitle: 'personal.timeline.scopeAreaTitle',
      scopeDateFromLabel: 'personal.timeline.scopeDateFromLabel',
      scopeDateRangeLabel: 'personal.timeline.scopeDateRangeLabel',
      holidayModelTitle: 'personal.timeline.holidayModelTitle',
      holidayAssignmentEditTitle:
        'personal.timeline.holidayAssignmentEditTitle',
      holidayNewAssignmentTitle: 'personal.timeline.holidayNewAssignmentTitle',
      holidayNewAssignmentPageTitle:
        'personal.timeline.holidayNewAssignmentPageTitle',
      timeModelTitle: 'personal.timeline.timeModelTitle',
      timeModelAssignmentEditTitle:
        'personal.timeline.timeModelAssignmentEditTitle',
      timeModelAssignmentTitle: 'personal.timeline.timeModelAssignmentTitle',
      timeModelAssignmentPageTitle:
        'personal.timeline.timeModelAssignmentPageTitle',
      timeModelAssignmentUCSameDayTitle:
        'personal.timeline.timeModelAssignmentUCSameDayTitle',
      timeModelAssignmentUCSameDayMessage:
        'personal.timeline.timeModelAssignmentUCSameDayMessage',
      timeModelAssignmentUCPastDayTitle:
        'personal.timeline.timeModelAssignmentUCPastDayTitle',
      timeModelAssignmentUCPastDayMessage:
        'personal.timeline.timeModelAssignmentUCPastDayMessage',
      timeModelAssignmentYearNotOpenedMessage:
        'personal.timeline.timeModelAssignmentYearNotOpenedMessage',
      organisationGroupTitle: 'personal.timeline.organisationGroupTitle',
      companyBranchTitle: 'personal.timeline.companyBranchTitle',
      companyBranchAssignmentEditTitle:
        'personal.timeline.companyBranchAssignmentEditTitle',
      companyBranchNewAssignmentTitle:
        'personal.timeline.companyBranchNewAssignmentTitle',
      companyBranchNewAssignmentPageTitle:
        'personal.timeline.companyBranchNewAssignmentPageTitle',
      departmendModelTitle: 'personal.timeline.departmendModelTitle',
      departmentAssignmentEditTitle:
        'personal.timeline.departmentAssignmentEditTitle',
      departmentNewAssignmentTitle:
        'personal.timeline.departmentNewAssignmentTitle',
      departmentNewAssignmentPageTitle:
        'personal.timeline.departmentNewAssignmentPageTitle',
      supervisorModelTitle: 'personal.timeline.supervisorModelTitle',
      supervisorAssignmentEditTitle:
        'personal.timeline.supervisorAssignmentEditTitle',
      supervisorNewAssignmentTitle:
        'personal.timeline.supervisorNewAssignmentTitle',
      supervisorNewAssignmentPageTitle:
        'personal.timeline.supervisorNewAssignmentPageTitle',
      workPeriodUCPersonIsWorkingTitle:
        'personal.timeline.workPeriodUCPersonIsWorkingTitle',
      workPeriodUCPersonIsWorkingDescription:
        'personal.timeline.workPeriodUCPersonIsWorkingDescription',
      workPeriodUCEndDateSmallerThenCurrentYearTitle:
        'personal.timeline.workPeriodUCEndDateSmallerThenCurrentYearTitle',
      workPeriodUCEndDateSmallerThenCurrentYearDescription:
        'personal.timeline.workPeriodUCEndDateSmallerThenCurrentYearDescription',
      workPeriodUCEndDateGreaterThenCurrentYearTitle:
        'personal.timeline.workPeriodUCEndDateGreaterThenCurrentYearTitle',
      workPeriodUCEndDateGreaterThenCurrentYearDescription:
        'personal.timeline.workPeriodUCEndDateGreaterThenCurrentYearDescription',
      workPeriodUCTimeEntriesDeleteDescription:
        'personal.timeline.workPeriodUCTimeEntriesDeleteDescription',
      workPeriodTimeEntriesAndDeletedSuccesfullMessage:
        'personal.timeline.workPeriodTimeEntriesAndDeletedSuccesfullMessage',
      workPeriodTimeEntriesAndDeletedFailedMessage:
        'personal.timeline.workPeriodTimeEntriesAndDeletedFailedMessage',
      workPeriodUCDeleteOption: 'personal.timeline.workPeriodUCDeleteOption',
      workPeriodDeleteWithTimeEntriesOption:
        'personal.timeline.workPeriodDeleteWithTimeEntriesOption',
      validFrom: 'personal.timeline.validFrom',
      validTo: 'personal.timeline.validTo',
      supervisorSelect: 'personal.supervisorSelect',
      requiredFieldsMessage: 'personal.timeline.requiredFieldsMessage',
      requiredDateRangeMessage: 'personal.timeline.requiredDateRangeMessage',
    },
    data: {
      timeEntriesTitle: 'personal.data.timeEntriesTitle',
      timeModel: 'personal.data.timeModel',
      balanceBooking: 'personal.data.balanceBooking',
      personData: 'personal.data.personData',
      warnings: 'personal.data.warnings',
    },
    options: {
      title: 'personal.options.title',
      general: 'personal.options.general',
      admia: 'personal.options.admia',
      comeAndGo: 'personal.options.comeAndGo',
      orderSelection: 'personal.options.orderSelection',
      costCenterSelection: 'personal.options.costCenterSelection',
      costCenterSelectionAll: 'personal.options.costCenterSelectionAll',
      costCenterSelectionDepartment:
        'personal.options.costCenterSelectionDepartment',
      absenceSelection: 'personal.options.absenceSelection',
      absenceSelectionRequestReason:
        'personal.options.absenceSelectionRequestReason',
      absenceSelectionFromGLZ: 'personal.options.absenceSelectionFromGLZ',
      serialPrints: 'personal.options.serialPrints',
      allowEditingTimes: 'personal.options.allowEditingTimes',
      allowEditComeAndGo: 'personal.options.allowEditComeAndGo',
      allowChange: 'personal.options.allowChange',
      allowAbsenceEdit: 'personal.options.allowAbsenceEdit',
      allowAbsenceRequest: 'personal.options.allowAbsenceRequest',
      sightRequired: 'personal.options.sightRequired',
      userPassword: 'personal.options.userPassword',
      anzeigeOption: 'personal.options.anzeigeOption',
      hideFerienInTagen: 'personal.options.hideFerienInTagen',
      terminalGroup: 'personal.options.terminalGroup',
    },
    mail: {
      title: 'personal.mail.title',
      popUpTitle: 'personal.mail.popUpTitle',
      okDeleteMail: 'personal.mail.okDeleteMail',
      dontDeleteMail: 'personal.mail.dontDeleteMail',
    },
    next: 'personal.next',
    previous: 'personal.previous',
    genders: {
      male: 'personal.genders.male',
      female: 'personal.genders.female',
    },
  };

  static holiday = {
    title: 'holiday.title',
    name: 'holiday.name',
    select: 'holiday.select',
  };

  static branch = {
    title: 'branch.title',
    name: 'branch.name',
    select: 'branch.select',
  };

  static order = {
    title: 'order.title',
    numberLong: 'order.numberLong',
    numberShort: 'order.numberShort',
    name: 'order.name',
    select: 'order.select',
    description: 'order.description',
    new: 'order.new',
    addition: 'order.addition',
    multiOrder: 'order.multiOrder',
    multiOrderFormCostCenter: 'order.multiOrderFormCostCenter',
    multiOrderFormOrder: 'order.multiOrderFormOrder',
    multiOrderFormValue: 'order.multiOrderFormValue',
    multiOrderNew: 'order.multiOrderNew',
    barcodetitle: 'order.barcode.title',
    project: 'order.project',
    precal: 'order.precal',
    costCenterDistribution: 'order.costCenterDistribution',
    costPerHour: 'order.costPerHour',
    detailed: 'order.detailed',
    overview: 'order.overview',
    all: 'order.all',
    inactive: 'order.inactive',
    active: 'order.active',
  };

  static operation = {
    title: 'operation.title',
    note: 'operation.note',
    select: 'operation.select',
    preCalc: 'operation.preCalc',
    operations: 'operation.operations',
  };

  static costCenter = {
    title: 'costCenter.title',
    numberShort: 'costCenter.numberShort',
    select: 'costCenter.select',
    costCenters: 'costCenter.costCenters',
  };

  static customer = {
    title: 'customer.title',
    numberLong: 'customer.numberLong',
    numberShort: 'customer.numberShort',
    name: 'customer.name',
    address: 'customer.address',
    zip: 'customer.zip',
    city: 'customer.city',
    text: 'customer.text',
  };

  static general = {
    name: 'general.name',
    cancel: 'general.cancel',
    save: 'general.save',
    execute: 'general.execute',
    select: 'general.select',
    sort: 'general.sort',
    dateTo: 'general.dateTo',
    dateFrom: 'general.dateFrom',
    to: 'general.to',
    toTitle: 'general.toTitle',
    from: 'general.from',
    fromTitle: 'general.fromTitle',
    decimalShort: 'general.decimalShort',
    take: 'general.take',
    loadMore: 'general.loadMore',
    total: 'general.total',
    general: 'general.general',
    description: 'general.description',
    number: 'general.number',
    here: 'general.here',
    notHere: 'general.notHere',
    today: 'general.today',
    back: 'general.back',
    selectAll: 'general.selectAll',
    server: 'general.server',
    serverNotFound: 'general.serverNotFound',
    selectOrderFirst: 'general.selectOrderFirst',
    selectCostCenterFirst: 'general.selectCostCenterFirst',
    chooseDate: 'general.chooseDate',
    address: 'general.address',
    phoneNumber: 'general.phoneNumber',
    privatePhoneNumber: 'general.privatePhoneNumber',
    mobile: 'general.mobile',
    mail: 'general.mail',
    yes: 'general.yes',
    no: 'general.no',
    okay: 'general.okay',
    send: 'general.send',
    terminate: 'general.terminate',
    terminateShort: 'general.terminateShort',
    naviationFailed: 'general.naviationFailed',
  };

  static absence = {
    title: 'absence.title',
    reason: 'absence.reason',
    createNew: 'absence.createNew',
    konto: 'absence.konto',
    select: 'absence.select',
  };

  static error = {
    servicePause: 'error.servicePause',
    offline: 'error.offline',
    general: 'error.general',
  };

  static login = {
    title: 'login.title',
    btnLogin: 'login.btnLogin',
    password: 'login.password',
    newPassword: 'login.newPassword',
    confirmPassword: 'login.confirmPassword',
    notMatchingPassword: 'login.notMatchingPassword',
    licenceNumber: 'login.licenceNumber',
    optional: 'login.optional',
    information: 'login.information',
    numberLong: 'login.numberLong',
    error: {
      general: 'login.error.general',
      personalNumber: 'login.error.personalNumber',
    },
  };

  static dayInfo = {
    overview: 'dayInfo.overview',
    title: 'dayInfo.title',
    date: 'dayInfo.date',
    dateTime: 'dayInfo.datetime',
    time: 'dayInfo.time',
    calendar: 'dayInfo.calendar',
    list: 'dayInfo.list',
    hours: 'dayInfo.hours',
    ksatz: 'dayInfo.ksatz',
    new: 'dayInfo.new',
    change: 'dayInfo.change',
    transform: 'dayInfo.transform',
    split: 'dayInfo.split',
    delete: 'dayInfo.delete',
    distribute: 'dayInfo.distribute',
    changeIndicator: 'dayInfo.changeIndicator',
    fullWork: 'dayInfo.fullWork',
    fullAbsence: 'dayInfo.fullAbsence',
    fullDate: 'dayInfo.fullDate',
    vacation: 'dayInfo.vacation',
    deleteAbsenceTitle: 'dayInfo.deleteAbsenceTitle',
    deleteAbsenceQuestion: 'dayInfo.deleteAbsenceQuestion',
    workInfoTitle: 'dayInfo.workInfoTitle',
    switchSmall: 'dayInfo.switchSmall',
    lastVisum: 'dayInfo.lastVisum',
    visumBy: 'dayInfo.visumBy',
    at: 'dayInfo.at',
    setVisum: 'dayInfo.setVisum',
    sureVisum: 'dayInfo.sureVisum',
    futureVisum: 'dayInfo.futureVisum',
    futureVisumWithTime: 'dayInfo.futureVisumWithTime',
    alreadyVisum: 'dayInfo.alreadyVisum',
    noVisum: 'dayInfo.noVisum',
    timeFrameHasVisum: 'dayInfo.timeFrameHasVisum',
    noPermissionsToOpenOrEdit: 'dayInfo.noPermissionsToOpenOrEdit',
  };

  static table = {
    columnsTitle: 'table.columnsTitle',
    column: 'table.column',
    filterGroupTitle: 'table.filterGroupTitle',
  };

  static settings = {
    theme: 'settings.theme',
    language: 'settings.language',
    darkMode: 'settings.darkMode',
    title: 'settings.title',
    showOperation: 'settings.showOperation',
    dayInfoViewState: 'settings.dayInfoViewState',
    dayInfoCombined: 'settings.dayInfoCombined',
    dayInfoTab: 'settings.dayInfoTab',
    expenseViewState: 'settings.expenseViewState',
    expenseCombined: 'settings.expenseCombined',
    expenseTab: 'settings.expenseTab',
    bookingViewState: 'settings.bookingViewState',
    bookingCombined: 'settings.bookingCombined',
    bookingTab: 'settings.bookingTab',
    sideMenu: 'settings.sideMenu',
    barcode: 'settings.barcode',
    system: 'settings.system',
    resetSettings: 'settings.resetSettings',
    askResetSettingsTitle: 'settings.askResetSettingsTitle',
    resetSettingsQuestionText: 'settings.resetSettingsQuestionText',
    resetSettingsDone: 'settings.resetSettingsDone',
    resetSettingsFailed: 'settings.resetSettingsFailed',
  };

  static reports = {
    title: 'reports.title',
    cardTimeLine: 'reports.cardTimeLine',
    singleReport: 'reports.singleReport',
    period: 'reports.period',
    detailed: 'reports.detailed',
    year: 'reports.year',
    quartal: 'reports.quartal',
    month: 'reports.month',
    week: 'reports.week',
    calendarWeek: 'reports.calendarWeek',
    fromDate: 'reports.fromDate',
    toDate: 'reports.toDate',
    filter: 'reports.filter',
    area: 'reports.area',
    noFilter: 'reports.noFilter',
    department: 'reports.department',
    subsidiary: 'reports.subsidiary',
    groupDis: 'reports.groupDis',
    absence: 'reports.absence',
    output: 'reports.output',
    email: 'reports.email',
    distribution: 'reports.distribution',
    preview: 'reports.preview',
    print: 'reports.print',
    file: 'reports.file',
    emailOrPrint: 'reports.emailOrPrint',
    archiveEmail: 'reports.archiveEmail',
    generate: 'reports.generate',
    notAuthorizedTitle: 'reports.notAuthorizedTitle',
    notAuthorizedMessage: 'reports.notAuthorizedMessage',
    notAuthorized: 'reports.notAuthorized',
    emailDistribution: 'reports.emailDistribution',
    titleSingle: 'reports.titleSingle',
    sorting: 'reports.sorting',
    orderPersonNr: 'reports.orderPersonNr',
    orderName: 'reports.orderName',
    orderDepartmentName: 'reports.orderDepartmentName',
    show: 'reports.show',
  };

  static timeEntryForm = {
    titleNew: 'timeEntryForm.titleNew',
    titleSplit: 'timeEntryForm.titleSplit',
    titleChange: 'timeEntryForm.titleChange',
    titleSwitch: 'timeEntryForm.titleSwitch',
    auto: 'timeEntryForm.auto',
    presence: 'timeEntryForm.presence',
    manual: 'timeEntryForm.manual',
    notEmpty: 'timeEntryForm.notEmpty',
    allFields: 'timeEntryForm.allFields',
    splitAbsenceNotPossible: 'timeEntryForm.splitAbsenceNotPossible',
    deleteQuestion: 'timeEntryForm.deleteQuestion',
    visumQuestion: 'timeEntryForm.visumQuestion',
    titleDelete: 'timeEntryForm.titleDelete',
    visumRemoveTitle: 'timeEntryForm.visumRemoveTitle',
    remove: 'timeEntryForm.remove',
    work: 'timeEntryForm.work',
    absenceType: 'timeEntryForm.absenceType',
    dateTimeHours: 'timeEntryForm.dateTimeHours',
    fromToOverlap: 'timeEntryForm.fromToOverlap',
    timeAsDefault: 'timeEntryForm.timeAsDefault',
  };

  static filter = {
    title: 'filter.title',
    column: 'filter.column',
  };

  static note = {
    title: 'note.title',
    newNoteForOrder: 'note.newNoteForOrder',
    editNoteOfOrder: 'note.editNoteOfOrder',
    titleList: 'note.titleList',
    deleteQuestion: 'note.deleteQuestion',
    date: 'note.date',
    dateTimeEntry: 'note.dateTimeEntry',
  };

  static quantity = {
    title: 'quantity.title',
    quantity: 'quantity.quantity',
    newQuantity: 'quantity.newQuantity',
    editQuantity: 'quantity.editQuantity',
    titleList: 'quantity.titleList',
    deleteQuestion: 'quantity.deleteQuestion',
  };

  static items = {
    price: 'items.price',
    unit: 'items.unit',
  };

  static expenses = {
    title: 'expenses.title',
    name: 'expenses.name',
    description: 'expenses.description',
    numberLong: 'expenses.numberLong',
    list: 'expenses.list',
    overview: 'expenses.overview',
    calendar: 'expenses.calendar',
    newExpenses: 'expenses.newExpenses',
    catalogueTitle: 'expenses.catalogueTitle',
    editExpenses: 'expenses.editExpenses',
    titleList: 'expenses.titleList',
    noImage: 'expenses.noImage',
    uploadImage: 'expenses.uploadImage',
    showReceipt: 'expenses.showReceipt',
    withReceipt: 'expenses.withReceipt',
    deleteQuestion: 'expenses.deleteQuestion',
    validationAllRequiredFields: 'expenses.validationAllRequiredFields',
  };

  static material = {
    title: 'material.title',
    catalogueTitle: 'material.catalogueTitle',
    titleList: 'material.titleList',
    titleNew: 'material.titleNew',
    titleEdit: 'material.titleEdit',
    titleCatalogue: 'material.titleCatalogue',
    deleteQuestion: 'material.deleteQuestion',
  };

  static badge = {
    workInfo: 'badge.workInfo',
    settingsTitle: 'badge.settingsTitle',
    position: 'badge.position',
    function: 'badge.function',
    autogehenMultiorder: 'badge.autogehenMultiorder',
    autogehenTime: 'badge.autogehenTime',
    autoghenExplained: 'badge.autoghenExplained',
    setAutogehen: 'badge.setAutogehen',
    workInfoStatusTitle: 'badge.workInfoStatusTitle',
    saldoUnitDay: 'badge.saldoUnitDay',
    saldoUnitHours: 'badge.saldoUnitHours',
  };

  static visa = {
    title: 'visa.title',
    titleSetVisa: 'visa.titleSetVisa',
    lblVisaTo: 'visa.lblVisaTo',
    btnSetVisa: 'visa.btnSetVisa',
    setVisumDialogTitle: 'visa.setVisumDialogTitle',
    setVisumDialogDescription: 'visa.setVisumDialogDescription',
    time: 'visa.time',
    msgVisedByAdmin: 'visa.msgVisedByAdmin',
    msgVisedBySupervisor: 'visa.msgVisedBySupervisor',
  };

  static report = {
    title: 'report.title',
    titleWithVisum: 'report.titleWithVisum',
    titleMultiple: 'report.titleMultiple',
    presence: 'report.presence',
    yearly: 'report.yearly',
    dateRange: 'report.dateRange',
    month: 'report.month',
    year: 'report.year',
    day: 'report.day',
    week: 'report.week',
    fullYear: 'report.fullYear',
    dateRangeIntern: 'report.dateRangeIntern',
    show: 'report.show',
    leistung: 'report.leistung',
    leistungOrder: 'report.leistungOrder',
    fullDay: 'report.fullDay',
    companyTitle: 'report.companyTitle',
  };

  static department = {
    title: 'department.title',
    name: 'department.name',
    numberLong: 'department.numberLong',
    select: 'department.select',
  };

  static absencePlaner = {
    title: 'absencePlaner.title',
    grouping: 'absencePlaner.grouping',
    filter: 'absencePlaner.filter',
    none: 'absencePlaner.none',
    filialen: 'absencePlaner.filialen',
    abteilung: 'absencePlaner.abteilung',
    groups: 'absencePlaner.groups',
    removeVisum: 'absencePlaner.removeVisum',
    oneMonth: 'absencePlaner.oneMonth',
    threeMonth: 'absencePlaner.threeMonth',
    sixMonth: 'absencePlaner.sixMonth',
    nineMonth: 'absencePlaner.nineMonth',
    year: 'absencePlaner.year',
    allAbsences: 'absencePlaner.allAbsences',
    people: 'absencePlaner.people',
    followingAbsences: 'absencePlaner.followingAbsences',
    confirmed: 'absencePlaner.confirmed',
    denied: 'absencePlaner.denied',
    reasonFor: 'absencePlaner.reasonFor',
    reasonForSuperior: 'absencePlaner.reasonForSuperior',
    noEmail: 'absencePlaner.noEmail',
    deniedAbsence: 'absencePlaner.deniedAbsence',
    confirmedAbsence: 'absencePlaner.confirmedAbsence',
    errorInConfirming: 'absencePlaner.errorInConfirming',
    accept: 'absencePlaner.accept',
    deny: 'absencePlaner.deny',
    show: 'absencePlaner.show',
  };

  static personalList = {
    title: 'personalList.title',
    picture: 'personalList.picture',
    showInactive: 'personalList.showInactive',
    amountOfPersons: 'personalList.amountOfPersons',
    amountOfInactivePersons: 'personalList.amountOfInactivePersons',
    noPermissionsToOpenPersonalDetailMessage:
      'personalList.noPermissionsToOpenPersonalDetailMessage',
  };

  static workflow = {
    title: 'workflow.title',
    sendEmail: 'workflow.sendEmail',
    validationsTitle: 'workflow.validationsTitle',
    validationResultMessage: 'workflow.validationResultMessage',
    emailValidationTitle: 'workflow.emailValidationTitle',
  };

  static warning = {
    title: 'warning.title',
    warning: 'warning.warning',
    delete: 'warning.delete',
    goTo: 'warning.goTo',
  };

  static defaultWork = {
    active: 'defaultWork.active',
    hasPassword: 'defaultWork.hasPassword',
    orderSelection: 'defaultWork.orderSelection',
    costCenterSelection: 'defaultWork.costCenterSelection',
  };

  static balanceBooking = {
    text: 'balanceBooking.text',
    fromAccount: 'balanceBooking.fromAccount',
    toAccount: 'balanceBooking.toAccount',
    auto: 'balanceBooking.auto',
    userName: 'balanceBooking.userName',
    time: 'balanceBooking.time',
    date: 'balanceBooking.date',
    list: 'balanceBooking.list',
    overview: 'balanceBooking.overview',
    calendar: 'balanceBooking.calendar',
  };
}
